/* Ines Iraola - cambio de foto en tarjetas de producto
   Ordenador: al pasar el cursor por encima muestra la siguiente foto del producto.
   Móvil/tablet: cuando la foto queda en el centro de la pantalla al hacer scroll muestra la siguiente foto. */
(function () {
  if (window.__iiSwap) return;
  window.__iiSwap = true;

  var css =
    '.card-wrapper .card__media .media>img.ii-swap{opacity:0!important;transition:opacity .45s ease!important;z-index:1}' +
    '.card-wrapper.ii-on .card__media .media>img.ii-swap{opacity:1!important}' +
    '.ii-nov__img>img.ii-swap{position:absolute!important;top:0;left:0;width:100%!important;height:100%!important;object-fit:cover;opacity:0;transition:opacity .45s ease;z-index:1;pointer-events:none}' +
    '.ii-nov__slide.ii-on .ii-nov__img>img.ii-swap{opacity:1}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function getProduct(h) {
    if (!cache[h]) {
      cache[h] = fetch(root + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function fname(u) {
    return (u || '').split('?')[0].split('/').pop().replace(/_\d*x\d*(?=\.[a-z]+$)/i, '');
  }
  function sized(u, w) {
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function whenLoaded(im, res) {
    if (im.complete && im.naturalWidth) return res(im);
    im.addEventListener('load', function () { res(im); }, { once: true });
    im.addEventListener('error', function () { res(null); }, { once: true });
  }

  function mediaOf(card) {
    return card.querySelector('.card__media .media') || card.querySelector('.ii-nov__img');
  }
  function prepare(card) {
    if (card.__ii) return card.__ii;
    card.__ii = new Promise(function (res) {
      var media = mediaOf(card);
      if (!media) return res(null);
      var imgs = [].filter.call(media.children, function (el) { return el.tagName === 'IMG'; });
      if (!imgs.length) return res(null);
      if (imgs.length > 1) {
        imgs[1].classList.add('ii-swap');
        imgs[1].loading = 'eager';
        return whenLoaded(imgs[1], res);
      }
      var h = handleOf(card);
      if (!h) return res(null);
      getProduct(h).then(function (p) {
        if (!p || !p.images || p.images.length < 2) return res(null);
        var cur = fname(imgs[0].currentSrc || imgs[0].src);
        var idx = -1;
        p.images.forEach(function (u, i) { if (idx < 0 && fname(u) === cur) idx = i; });
        var next = idx < 0 ? p.images[1] : p.images[(idx + 1) % p.images.length];
        if (!next || fname(next) === cur) return res(null);
        var w = Math.min(1600, Math.ceil(((media.clientWidth || 400) * (window.devicePixelRatio || 1)) / 100) * 100);
        var im = document.createElement('img');
        im.className = 'ii-swap ' + (imgs[0].className || '');
        im.alt = imgs[0].alt || '';
        im.decoding = 'async';
        im.loading = 'eager';
        im.setAttribute('aria-hidden', 'true');
        var br = getComputedStyle(imgs[0]).borderRadius;
        if (br && br !== '0px') im.style.borderRadius = br;
        im.src = sized(next, w);
        media.appendChild(im);
        whenLoaded(im, res);
      });
    });
    return card.__ii;
  }

  function on(card) {
    card.__iiWant = true;
    prepare(card).then(function (im) { if (im && card.__iiWant) card.classList.add('ii-on'); });
  }
  function off(card) {
    card.__iiWant = false;
    card.classList.remove('ii-on');
  }

  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var centerIO, nearIO;
  if (!desktop && 'IntersectionObserver' in window) {
    centerIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var c = e.target.closest('.card-wrapper');
        if (c) e.isIntersecting ? on(c) : off(c);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    nearIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { prepare(e.target); nearIO.unobserve(e.target); } });
    }, { rootMargin: '300px 0px 300px 0px', threshold: 0 });
  }

  function bind(card, hoverOnly) {
    if (card.__iiBound) return;
    card.__iiBound = true;
    if (desktop) {
      card.addEventListener('mouseenter', function () { on(card); });
      card.addEventListener('mouseleave', function () { off(card); });
    } else if (centerIO && !hoverOnly) {
      centerIO.observe(card.querySelector('.card__media') || card);
      nearIO.observe(card);
    }
  }
  function bindAll() {
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      if (c.querySelector('.card__media .media')) bind(c);
    });
    document.querySelectorAll('.ii-nov__slide').forEach(function (c) {
      if (c.querySelector('.ii-nov__img')) bind(c, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
  else bindAll();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(bindAll, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
